import Contact from './index.vue'

export default {
	install (Vue, options = {}) {
		const VueContact = Vue.extend(Contact);
		let contact = null

		function $contact() {
			if (!contact) {
				contact = new VueContact();

				contact.$mount();

				document.querySelector(options.container || 'body').appendChild(contact.$el);
			}

			return contact.showContact();
		}

		Vue.prototype.$contact = $contact
	}
}